var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArbitrum(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8Z",
    fill: "#081327"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.02408 9.27085L9.23399 11.1652L10.3516 10.519L8.76266 8.02063L8.02408 9.27085Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3705 9.75946L11.3697 9.24178L9.63343 6.54403L8.9893 7.6344L10.6654 10.3386L11.2714 9.98831C11.3309 9.94015 11.3668 9.86947 11.3706 9.79319L11.3705 9.75946Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.09378 10.2474L4.94957 10.7393L7.79746 6.18317L7.31409 6.17045C6.90228 6.16464 6.45865 6.27143 6.25504 6.60301L4.63782 9.10357L4.09375 9.93757L4.09378 10.2474Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.44115 6.18317L8.16729 6.18779L5.28527 10.9321L6.29228 11.5112L6.56654 11.0472L9.44115 6.18317Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9062 6.17674C11.8956 5.91098 11.7514 5.66765 11.5254 5.52603L8.35856 3.70927C8.13506 3.59699 7.85585 3.59685 7.63199 3.70919C7.60551 3.7225 4.55227 5.48899 4.55227 5.48899C4.51003 5.50919 4.46933 5.53328 4.43104 5.5606C4.22933 5.7048 4.10638 5.92887 4.09375 6.17511V9.93757L4.63782 9.10357L4.63305 6.20044C4.63371 6.18982 4.63507 6.17928 4.63692 6.16893C4.64928 6.10065 4.68749 6.03979 4.74501 5.99863C4.75938 5.98837 7.86476 4.19521 7.87465 4.19027C7.94761 4.15369 8.04034 4.15331 8.11346 4.18916L11.2393 5.98284C11.3133 6.02985 11.3597 6.10951 11.3638 6.19658L11.3638 9.79299C11.36 9.86928 11.3298 9.93979 11.2704 9.98795L10.6643 10.3383L10.3516 10.519L9.23399 11.1652L8.10055 11.8205C8.03951 11.8424 7.9681 11.8412 7.90758 11.8167L6.56654 11.0472L6.29228 11.5112L7.49775 12.203C7.53758 12.2256 7.5731 12.2456 7.60224 12.262C7.64738 12.2872 7.67812 12.3041 7.68896 12.3093C7.7746 12.3508 7.89783 12.375 8.00891 12.375C8.11074 12.375 8.21001 12.3563 8.30398 12.3196L11.5961 10.4177C11.7851 10.2716 11.8962 10.0514 11.9062 9.8128V6.17674Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "border",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 15.5C12.1421 15.5 15.5 12.1421 15.5 8C15.5 3.85786 12.1421 0.5 8 0.5C3.85786 0.5 0.5 3.85786 0.5 8C0.5 12.1421 3.85786 15.5 8 15.5ZM8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z",
    fill: "#36F7D3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArbitrum);
export default __webpack_public_path__ + "static/media/arbitrum.446f74dbea345b6ecda6a162bc2b6084.svg";
export { ForwardRef as ReactComponent };